<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-7">
            <h5 class="card-title">Inspektionen</h5>
          </div>
          <div class="col-sm-5 pt-1 text-right">
            <p-button type="success" @click="newInspection()" title="Inspektion anlegen" class="mt-0 mr-0" :disabled="constructionRole < 2"><i class="bi bi-plus-circle" style="font-size: 16px;"></i> Inspektion anlegen</p-button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <collapse v-if="inspections.length > 0" :multiple-active=false :active-index=activeInspection accordion>
              <collapse-item-construction :name="inspection.key" :title="inspection.inspectionTitle" :completedParcoursCount="inspection.completedParcoursCount" :parcoursCount="inspection.parcoursCount" v-for="inspection in inspections" :key="inspection.key">
                <p-button type="default" size="sm" class="mb-2" @click="createReport(inspection.key)" v-if="constructionRole >= 2" >Bericht erstellen</p-button>
                <p-button type="default" link size="sm" class="mb-2" title="Titel bearbeiten" @click="renameInspection(inspection.key)" v-if="constructionRole == 4" ><i class="bi bi-pencil-square" style="font-size: 16px;"></i></p-button>
                <p-button type="default" link size="sm" class="mb-2" title="Inspektion löschen" @click="removeInspection(inspection.key)" v-if="constructionRole == 4" ><i class="bi bi-trash" style="font-size: 16px;"></i></p-button>
                <el-table :data="inspection.parcours" style="width: 100%;margin-bottom: 20px;" border>
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-table :data="props.row.Elements" class="ml-3 mr-3" style="width: 100%; margin-top: 10px;" border>
                        <el-table-column
                          prop="elementName"
                          label="Element">
                        </el-table-column>
                        <el-table-column
                          prop="elementType"
                          label="Typ">
                        </el-table-column>
                        <el-table-column
                          label="Status">
                          <template slot-scope="scope">
                            <i class="bi bi-check-circle-fill" v-if="scope.row.elementStatus == 'Abgeschlossen'" style="color: green; font-size: 20px;" title="Inspektion abgeschlossen"></i>
                            <i class="bi bi-hourglass" v-if="scope.row.elementStatus == 'Offen'" style="color: orange; font-size: 20px;" title="Inspektion ausstehend"></i>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Prüfer">
                          <template slot-scope="scope">
                            <span v-if="scope.row.elementPruefer != ''">{{ scope.row.elementPruefer }}</span>
                            <span v-else> - </span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="Name"
                    label="Parcours"
                    >
                  </el-table-column>
                  <el-table-column
                    label="Status">
                    <template slot-scope="scope">
                      <el-progress :text-inside="true" :stroke-width="20" :percentage="scope.row.percentageCompleted"  style="max-width: 200px;" class="mt-1"></el-progress>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="">
                    <template slot-scope="scope">
                      <p-button type="default" size="sm" @click="startCheck(inspection.key, scope.row.key)" v-if="scope.row.completedElementsCount < scope.row.elementsCount && constructionRole >= 2">Inspek. starten</p-button>
                    </template>
                  </el-table-column>
                </el-table>
              </collapse-item-construction>
            </collapse>
      </div>
    </div>

    <modal :show.sync="showNewInspectionModal" headerClasses="justify-content-center">
      <h5 slot="header" class="title mb-0">Inspektion anlegen</h5>
      <div class="row">
        <div class="col">
          <label class="pt-1">Art der Inspektion:</label>
          <el-select v-model="newInspectionTemplate" placeholder="Art der Inspektion auswählen" clearable @change="setTitle()">
            <el-option v-for="template in inspectionTemplates" :value=template :label=template :key=template></el-option>
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="pt-4">Titel:</label>
          <el-input v-model="newInspectionTitle" :disabled="newInspectionTemplate == ''"></el-input>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="showNewInspectionModal=false">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="addInspection()" :disabled="newInspectionTemplate == '' || newInspectionTitle == ''">Anlegen</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { db, fc } from "../../../../firebaseDb";
import { Table, TableColumn, Input, Loading, Popover, Tag, Select, Option, Statistic, Progress, MessageBox } from "element-ui";
import { Modal } from "src/components/UIComponents";
import Collapse from '../../../UIComponents/Collapse/Collapse.vue';
import CollapseItemConstruction from '../../../UIComponents/Collapse/CollapseItemConstruction.vue';
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import SelectLocation from '/src/components/KET/Views/Components/KETSelectLocation.vue'
import { httpsCallable } from "firebase/functions";
import { remove } from "nprogress";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Popover);
Vue.use(Loading);
Vue.use(Tag)
Vue.use(Statistic)

export default {
  components: {
    [Input.name]: Input,
    SelectLocation,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    [Progress.name]: Progress,
    Collapse,
    CollapseItemConstruction,
    MessageBox,
  },

  data() {
    return {
      loading: true,
      inspections: [],
      showNewInspectionModal: false,
      inspectionTemplates: ['Wochen-Inspektion', 'Monats-Inspektion', 'Jahres-Inspektion'],
      newInspectionTemplate: "",
      newInspectionTitle: "",
      activeInspectionId: null,
      unsubscribeInspections: null,
      inspectionsLoadRun: 0,
      activeInspection: -1,
      parcoursNameDone: null,
      role: store.getters.userrole,
      location: store.getters.userlocation,
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
          firstDayOfWeek: 1,
          shortcuts: []
        },
      constructionRole: store.getters.constructionRole,
    };
  },
  created() {
    if(store.getters.constructionRole == "0") {
      MessageBox.alert(
        "Zugriff verweigert.",
        {
          confirmButtonText: "OK",
          type: "error",
          callback: (action) => {
            router.push({ name: 'Overview' })
          },
        }
      );
    }
    moment.locale("de");
    this.activeInspectionId = this.$route.params.inspectionId || null;
    this.parcoursNameDone = this.$route.params.parcoursNameDone || null; 
    if (this.parcoursNameDone) {
      this.$notify({
        message: "Die Inspektion des Parcours '" + this.parcoursNameDone + "' wurde erfolgreich abgeschlossen!",
        icon: "fa fa-check-circle",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success",
        showClose: true,
        timeout: 5000,
      });
    }
    this.loadInspections();
    this.unwatchLocation = store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadInspections();
      }
    );
  },
  beforeDestroy() {
    this.unwatchLocation();
    if (this.unsubscribeInspections) {
      this.unsubscribeInspections();
    }
  },
  methods: {
    setTitle() {
      if (this.newInspectionTemplate != '') {
        if (this.newInspectionTemplate == 'Wochen-Inspektion') {
          this.newInspectionTitle = this.newInspectionTemplate + " - KW " + moment().format("WW YYYY");
        } else if (this.newInspectionTemplate == 'Monats-Inspektion') {
          this.newInspectionTitle = this.newInspectionTemplate + " - " + moment().format("MMM YYYY");
        } else if (this.newInspectionTemplate == 'Jahres-Inspektion') {
          this.newInspectionTitle = this.newInspectionTemplate + " - " + moment().format("YYYY");
        }
      }
    },
    loadInspections() {
      if (this.unsubscribeInspections) {
        this.unsubscribeInspections();
      }
      // get inspection data from firebase
      const inspectionRef = db.collection("constructionInspections");
      this.unsubscribeInspections = inspectionRef.where('locationID', '==', this.location).orderBy("Date", "desc").onSnapshot((snapshotChange) => {
        // Results of an older snapshot that resolve late must not be mixed into the current list
        const loadRun = ++this.inspectionsLoadRun;
        const sourceElementsCache = {};
        this.inspections = [];
        const inspectionPromises = snapshotChange.docs.map((doc) => {
          const parcours = [];
          let parcoursCount = 0;
          return db.collection("constructionInspections").doc(doc.id).collection("parcours").orderBy("Name").get().then((parcSnapshot) => {
            parcoursCount = 0;
            const parcoursPromises = [];
            parcSnapshot.forEach((parcDoc) => {
              parcoursCount += 1;
              const p = db.collection("constructionInspections").doc(doc.id).collection("parcours").doc(parcDoc.id).collection("elements").orderBy("elementPosition").get().then((elemSnapshot) => {
                const loadedElements = [];
                elemSnapshot.forEach((elemDoc) => {
                  loadedElements.push(this.toElementListEntry(elemDoc.id, elemDoc.data()));
                });
                return this.repairMissingElements(doc.id, parcDoc, loadedElements, sourceElementsCache);
              }).then((elements) => {
                const elementsCount = elements.length;
                const completedElementsCount = elements.filter(elem => elem.elementStatus !== 'Offen').length;
                let percentageCompleted = 0;
                if (elementsCount > 0) {
                  const raw = (completedElementsCount / elementsCount) * 100;
                  // Ensure valid integer 0–100 to satisfy el-progress validator
                  percentageCompleted = Math.min(100, Math.max(0, Math.round(raw)));
                }
                parcours.push({
                  key: parcDoc.id,
                  Name: parcDoc.data().Name,
                  Status: parcDoc.data().Status,
                  Elements: elements,
                  elementsCount: elementsCount,
                  completedElementsCount: completedElementsCount,
                  percentageCompleted: percentageCompleted,
                });
              });
              parcoursPromises.push(p);
            });
            return Promise.all(parcoursPromises).then(() => {
              // Ensure stable client-side sort by Name regardless of async resolution order
              parcours.sort((a, b) => (a.Name || '').localeCompare((b.Name || ''), 'de', { sensitivity: 'base' }));
              const completedParcoursCount = parcours.filter(parc => parc.Status === 'Abgeschlossen').length;
              return {
                key: doc.id,
                inspectionTemplate: doc.data().Template,
                inspectionTitle: doc.data().Title,
                inspectionDate: new Date(doc.data().Date.seconds * 1000),
                inspectionStatus: doc.data().Status,
                parcours: parcours,
                parcoursCount: parcoursCount,
                completedParcoursCount: completedParcoursCount,
              };
            });
          }).catch((error) => {
            console.error("Error loading inspection " + doc.id + ":", error);
            return null;
          });
        });
        // Promise.all keeps the query order (Date desc), so the newest inspection is on top
        Promise.all(inspectionPromises).then((loadedInspections) => {
          if (loadRun !== this.inspectionsLoadRun) {
            return;
          }
          this.inspections = loadedInspections.filter(inspection => inspection !== null);
          if (this.activeInspectionId) {
            const index = this.inspections.findIndex(inspection => inspection.key === this.activeInspectionId);
            if (index !== -1) {
              this.activeInspection = index;
            }
          } else if (this.activeInspection === -1 && this.inspections.length > 0) {
            this.activeInspection = 0;
          }
          this.loading = false;
        });
      });
    },
    toInspectionElement(sourceData) {
      return {
        elementPosition: sourceData.elementPosition,
        elementName: sourceData.elementName || '',
        elementType: sourceData.elementType || '',
        elementChecks: sourceData.elementChecks || [],
        elementStatus: 'Offen',
      };
    },
    toElementListEntry(key, data) {
      return {
        key: key,
        elementName: data.elementName,
        elementType: data.elementType,
        elementStatus: data.elementStatus,
        elementPruefer: data.elementPruefer || '',
        elementPosition: data.elementPosition,
      };
    },
    // Inspections created before batched writes could be cut off mid-copy (e.g. tab closed),
    // leaving parcours with no or only the first few elements. Append the missing ones.
    repairMissingElements(inspectionId, parcDoc, elements, sourceElementsCache) {
      if (!(this.constructionRole >= 2) || parcDoc.data().Status === 'Abgeschlossen') {
        return Promise.resolve(elements);
      }
      if (!sourceElementsCache[parcDoc.id]) {
        sourceElementsCache[parcDoc.id] = db.collection("parcours").doc(parcDoc.id).collection("elements").orderBy("elementPosition").get().then((snapshot) => snapshot.docs);
      }
      return sourceElementsCache[parcDoc.id].then((sourceDocs) => {
        if (elements.length >= sourceDocs.length) {
          return elements;
        }
        // Only a truncated copy matches the source exactly up to where it stops; anything else was changed on purpose
        const isTruncatedCopy = elements.every((elem, index) =>
          elem.elementName === sourceDocs[index].data().elementName &&
          elem.elementPosition === sourceDocs[index].data().elementPosition
        );
        if (!isTruncatedCopy) {
          return elements;
        }
        const elementsRef = db.collection("constructionInspections").doc(inspectionId).collection("parcours").doc(parcDoc.id).collection("elements");
        const batch = db.batch();
        const addedElements = sourceDocs.slice(elements.length).map((sourceDoc) => {
          const data = this.toInspectionElement(sourceDoc.data());
          // Source ID as doc ID keeps concurrent repairs by several users idempotent
          batch.set(elementsRef.doc(sourceDoc.id), data);
          return this.toElementListEntry(sourceDoc.id, data);
        });
        return batch.commit().then(() => elements.concat(addedElements));
      }).catch((error) => {
        console.error("Error repairing elements of parcours " + parcDoc.id + " in inspection " + inspectionId + ":", error);
        return elements;
      });
    },
    newInspection() {
      this.newInspectionTemplate = "";
      this.newInspectionTitle = "";
      this.showNewInspectionModal = true;
    },
    addInspection() {
      const newInspectionRef = db.collection("constructionInspections").doc();
      const inspectionData = {
        Template: this.newInspectionTemplate,
        Title: this.newInspectionTitle,
        Date: new Date(),
        Status: 'Offen',
        locationID: this.location,
      };
      const loading = this.$loading({
        lock: true,
        text: 'Inspektion wird angelegt...',
        spinner: 'el-icon-loading'
      });
      const preventUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
      };
      window.addEventListener('beforeunload', preventUnload);
      this.loading = true;
      db.collection("parcours").where('locationID', '==', this.location).orderBy('position').get().then((parcoursSnapshot) => {
        return Promise.all(parcoursSnapshot.docs.map((parcDoc) =>
          parcDoc.ref.collection("elements").orderBy("elementPosition").get().then((elementsSnapshot) => ({
            parcDoc: parcDoc,
            elementDocs: elementsSnapshot.docs,
          }))
        ));
      }).then((parcoursList) => {
        const writes = [];
        parcoursList.forEach(({ parcDoc, elementDocs }) => {
          const parcRef = newInspectionRef.collection("parcours").doc(parcDoc.id);
          writes.push({ ref: parcRef, data: { Name: parcDoc.data().Name || '', Status: 'Offen' } });
          elementDocs.forEach((elementDoc) => {
            writes.push({ ref: parcRef.collection("elements").doc(elementDoc.id), data: this.toInspectionElement(elementDoc.data()) });
          });
        });
        // Written last, so the inspection only appears once all parcours and elements exist
        writes.push({ ref: newInspectionRef, data: inspectionData });
        // Firestore allows max. 500 operations per batch
        const batchSize = 400;
        let commitChain = Promise.resolve();
        for (let i = 0; i < writes.length; i += batchSize) {
          const chunk = writes.slice(i, i + batchSize);
          commitChain = commitChain.then(() => {
            const batch = db.batch();
            chunk.forEach((write) => batch.set(write.ref, write.data));
            return batch.commit();
          });
        }
        return commitChain.then(() => newInspectionRef.id);
      }).then((newInspectionId) => {
        // Now all writes are complete; refresh UI and notify
        this.showNewInspectionModal = false;
        this.newInspectionTemplate = "";
        this.newInspectionTitle = "";
        this.$notify({
          message: "Inspektion wurde erfolgreich angelegt!",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
        this.inspections = [];
        // Optionally set the active inspection to the newly created one
        this.activeInspectionId = newInspectionId;
        this.loadInspections();
      }).catch((error) => {
        console.error("Error creating inspection:", error);
        this.$notify({
          message: "Fehler beim Erstellen der Inspektion: " + error.message,
          icon: "fa fa-times-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "error",
          showClose: true,
          timeout: 5000,
        });
      }).finally(() => {
        window.removeEventListener('beforeunload', preventUnload);
        loading.close();
        this.loading = false;
      });
    },
    showDetails(row, column) {
      if (column.property) {
        router.push({ name: "PsaDetails", params: { psaId: row.key } });
      }
    },
    removeInspection(inspectionId) {
      MessageBox.confirm(
        "Soll diese Inspektion wirklich gelöscht werden? Der Vorgang kann nicht rückgängig gemacht werden!",
        "Inspektion löschen",
        {
          confirmButtonText: "Löschen",
          cancelButtonText: "Abbrechen",
          type: "warning",
        }
      ).then(() => {
        // delete inspection
        db.collection("constructionInspections").doc(inspectionId).delete().then(() => {
          this.$notify({
            message: "Die Inspektion wurde erfolgreich gelöscht!",
            icon: "fa fa-check-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success",
            showClose: true,
            timeout: 5000,
          });
        });
      }).catch(() => {
        // cancelled
      });
    },
    renameInspection(inspectionId) {
      MessageBox.prompt('Neuer Titel der Inspektion:', 'Inspektion umbenennen', {
        confirmButtonText: 'Speichern',
        cancelButtonText: 'Abbrechen',
        inputValue: this.inspections.find(inspection => inspection.key === inspectionId).inspectionTitle,
      }).then(({ value }) => {
        db.collection("constructionInspections").doc(inspectionId).update({
          Title: value,
        }).then(() => {
          this.$notify({
            message: "Der Titel der Inspektion wurde erfolgreich geändert!",
            icon: "fa fa-check-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success",
            showClose: true,
            timeout: 5000,
          });
        });
      }).catch(() => {
        // cancelled
      });
    },
    updateLocation(loc) {
      this.location = loc
      this.loadPsa()
    },
    startCheck(inspectionId, parcoursId) {
      router.push({ name: "InspectionCheck", params: { inspectionId: inspectionId, parcoursId: parcoursId } });
    },
    createReport(inspectionId) {
      const loading = this.$loading({
          lock: true,
          text: 'Bericht wird erstellt...',
          spinner: 'el-icon-loading'
        });
        console.log("Start report generation for inspection " + inspectionId)
        var generateReport = httpsCallable(fc, "constructionreports-generateInspectionReport");
        
        generateReport({inspectionId: inspectionId}).then((result) => {
          console.log('Report done')
          // open new window with report url
          const reportUrl = result.data.url;
          const reportFilename = result.data.name;
          //window.open(reportUrl, '_blank');
          router.push({ name: "Print", params: { file: reportFilename, link: reportUrl } });
          this.$notify({
            message: "Der Bericht wurde erfolgreich erstellt!",
            icon: "fa fa-check-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success",
            showClose: true,
            timeout: 5000,
          });
        }).catch((error) => {
          console.error("Error generating report: ", error);
          this.$notify({
            message: "Fehler beim Erstellen des Berichts: " + error.message,
            icon: "fa fa-times-circle",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "error",
            showClose: true,
            timeout: 5000,
          });
        }).finally(() => {
          loading.close()
        });
    },
  },
};
</script>
<style>
.el-tag {
  color: white !important;
}
</style>
